import React, { useState } from 'react';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { SignIn } from './components/Auth/SignIn';
import { OTP } from './components/Auth/OTP';
import { Dashboard } from './components/Dashboard/Dashboard';
import './App.css';

type Page = 'signin' | 'otp' | 'dashboard';

const AppContent: React.FC = () => {
  const { user, logout } = useAuth();
  const [page, setPage] = useState<Page>(user ? 'dashboard' : 'signin');

  if (page === 'signin') {
    return <SignIn onSuccess={() => setPage('otp')} />;
  }

  if (page === 'otp') {
    return (
      <OTP
        onSuccess={() => setPage('dashboard')}
        onBack={() => setPage('signin')}
      />
    );
  }

  return <Dashboard onLogout={() => { logout(); setPage('signin'); }} />;
};

const App: React.FC = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;
